"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanel.default;
  }
});

var _ExpansionPanel = _interopRequireDefault(require("./ExpansionPanel"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/ExpansionPanel/index.js
 ** module id = 846
 ** module chunks = 0
 **/